import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { LoadingFallback } from './components/LoadingFallback';

/**
 * Stage 5.X.1 (skeleton): только `/` (Home placeholder) + `*` (NotFound).
 *
 * Stage 5.X.2-5.X.7 добавит:
 *   - `/login` (Stage 5.X.2)
 *   - `/consent` (Stage 5.X.10)
 *   - `/profile` (Stage 5.X.3) — главный экран после auth
 *   - `/subscribe` + `/subscribe/confirm` + `/subscribe/success` (Stage 5.X.4)
 *   - `/receipts` + `/receipts/:id` (Stage 5.X.5)
 *   - `/onboarding/:step` (Stage 5.X.6)
 *   - `/settings` (Stage 5.X.7)
 *
 * См. docs/tg-miniapp.md §2 (карта страниц).
 */

const Home = lazy(() => import('./pages/Home').then((m) => ({ default: m.Home })));
const NotFound = lazy(() =>
  import('./pages/NotFound').then((m) => ({ default: m.NotFound })),
);

export function AppRouter(): JSX.Element {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Suspense>
  );
}
